"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var reconfigureButtonStyles = styles_1.makeStyles({
    buttonWithArrowContainer: {
        display: 'flex',
        justifyContent: 'center',
        padding: '20px 0',
    },
    buttonContainer: {
        padding: '30px 0',
        display: 'block',
    },
    reconfigureBtn: {
        margin: 'auto',
        display: 'block',
        maxWidth: 500,
    },
    btnLabel: {
        letterSpacing: 2,
        textTransform: 'uppercase',
    },
    buttonHideIcon: {
        '&': {
            display: 'none',
        },
    },
    buttonNoRadius: {
        '&': {
            paddingRight: 0,
            paddingLeft: 0,
            borderRadius: 0,
        },
    },
    buttonReconfigure: {},
}, { name: 'GqlSummary_ReconfigureButton' });
exports.default = reconfigureButtonStyles;
